var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8004 1.02011C16.1251 0.953916 16.4669 1.05273 16.7071 1.29292L22.7071 7.29292C22.8946 7.48046 23 7.73481 23 8.00003V14.19C23 16.2923 21.2923 18 19.19 18C18.6377 18 18.19 17.5523 18.19 17C18.19 16.4477 18.6377 16 19.19 16C20.1877 16 21 15.1877 21 14.19V9.00003H19C17.8196 9.00003 16.7145 8.8162 15.9491 8.05089C15.1838 7.28557 15 6.18043 15 5.00003V3.00003H10C8.89228 3.00003 8 3.89231 8 5.00003C8 5.55231 7.55228 6.00003 7 6.00003C6.44772 6.00003 6 5.55231 6 5.00003C6 2.78774 7.78772 1.00003 10 1.00003H15.6C15.6686 1.00003 15.7356 1.00694 15.8004 1.02011ZM17 4.41424L19.5858 7.00003H19C17.9304 7.00003 17.5355 6.80886 17.3634 6.63667C17.1912 6.46448 17 6.06963 17 5.00003V4.41424ZM4.00711 9.00714C3.3864 9.62784 3 10.6987 3 12.6V16.4C3 18.3014 3.3864 19.3722 4.00711 19.9929C4.62782 20.6136 5.69863 21 7.6 21H11.4C13.3014 21 14.3722 20.6136 14.9929 19.9929C15.6136 19.3722 16 18.3014 16 16.4V14.4H13.8C12.5446 14.4 11.3895 14.2037 10.5929 13.4071C9.79633 12.6106 9.6 11.4554 9.6 10.2V8.00003H7.6C5.69863 8.00003 4.62782 8.38643 4.00711 9.00714ZM11.6 9.41424L14.5858 12.4H13.8C12.6554 12.4 12.2105 12.1964 12.0071 11.9929C11.8037 11.7895 11.6 11.3446 11.6 10.2V9.41424ZM2.59289 7.59292C3.77218 6.41363 5.50137 6.00003 7.6 6.00003H10.6C10.8652 6.00003 11.1196 6.10539 11.3071 6.29292L17.7071 12.6929C17.8946 12.8805 18 13.1348 18 13.4V16.4C18 18.4987 17.5864 20.2278 16.4071 21.4071C15.2278 22.5864 13.4986 23 11.4 23H7.6C5.50137 23 3.77218 22.5864 2.59289 21.4071C1.4136 20.2278 1 18.4987 1 16.4V12.6C1 10.5014 1.4136 8.77221 2.59289 7.59292Z",
    fill: "#ABABAB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.36ef641a0f3f27fdd704e099db020397.svg";
export { ForwardRef as ReactComponent };